export const SHOW_COMPANY_COUNTRY_CURRENCY = 'checkout/contacts/SHOW_COMPANY_COUNTRY_CURRENCY';

export const showCompanyCountryCurrency = (showCurrency: boolean) => ({
  type: SHOW_COMPANY_COUNTRY_CURRENCY,
  payload: showCurrency,
});
